import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from 'components/layout/PageHeader'
import type { TimeRange } from './ConsumptionStats'

interface DashboardHeaderProps {
  timeRange: TimeRange
  onTimeRangeChange: (range: TimeRange) => void
}

const TIME_RANGES: TimeRange[] = ['day', 'week', 'month', 'year', 'all']

export function DashboardHeader({ timeRange, onTimeRangeChange }: DashboardHeaderProps) {
  const { t } = useTranslation()

  return (
    <PageHeader
      title={t('dashboard.title')}
      className="lg:h-[61px]"
      actions={
        <div className="flex w-full flex-wrap items-center gap-1 rounded-md bg-muted p-1 lg:w-auto lg:flex-nowrap">
          {TIME_RANGES.map((range) => {
            const isActive = range === timeRange
            return (
              <button
                key={range}
                type="button"
                onClick={() => onTimeRangeChange(range)}
                className={`h-8 rounded-md px-2.5 text-[11px] font-medium transition-colors sm:px-3 sm:text-xs ${
                  isActive
                    ? 'bg-[#19A6A6] text-white'
                    : 'bg-transparent text-muted-foreground hover:bg-background hover:text-foreground'
                }`}
              >
                {t(`organizations.stats.timeRanges.${range}`)}
              </button>
            )
          })}
        </div>
      }
    />
  )
}
